import { isProduction, hasMarket } from '~components/utils/env-helpers';

const NETLIFY_FORMSTACK_FUNCTION_URI = 'https://join.efhighschool.com/.netlify/functions/fetchForm'

const fetchFields = (formId: string) => {
  return fetch(`${NETLIFY_FORMSTACK_FUNCTION_URI}?formid=${formId}`);
};

const submitForm = (body: any, formId: string) => {
  return fetch(`${NETLIFY_FORMSTACK_FUNCTION_URI}?formid=${formId}`, {
    body: JSON.stringify(body),
    mode: "no-cors",
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });
};

export {
  fetchFields,
  submitForm,
};
